var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnLayout, styled } from '@a0/quantum-product';
import Fuse from 'fuse.js';
import { each, filter } from 'lodash';
import * as React from 'react';
import { StickyContainer } from 'react-sticky';
import QuickstartStore from '../../../stores/QuickstartStore';
import { useFluxible } from '../../hooks/useFluxible';
import SearchField from '../../SearchField';
import { Category } from './components/Category';
import { Hero } from './components/Hero';
import { Sidebar } from './components/Sidebar';
import { CATEGORIES } from './data';
import styles from './styles.module.styl';
var SEARCH_DEFAULTS = {
    threshold: 0.1,
    location: 0,
    maxPatternLength: 100,
    minMatchCharLength: 1,
    keys: ['title', 'name'],
};
var doSearch = function (categories, term) {
    if (!term)
        return { quickstarts: categories, noResults: false };
    var quickstarts = {};
    var noResults = true;
    each(categories, function (categoryQuickstarts, category) {
        var results = new Fuse(categoryQuickstarts, SEARCH_DEFAULTS).search(term);
        if (results.length) {
            noResults = false;
        }
        quickstarts[category] = results.map(function (result) { return result.item; });
    });
    return { quickstarts: quickstarts, noResults: noResults };
};
var Container = styled(ColumnLayout)(function () { return ({
    maxWidth: 1440,
    margin: '0 auto',
}); });
var SidebarContainer = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            borderRight: '1px solid #BDC4CF'
        },
        _b[theme.breakpoints.down('sm')] = {
            display: 'none',
        },
        _b);
});
var MainContentContainer = styled('div')(function () { return ({
    paddingTop: '56px',
}); });
export var QuickstartsPage = function (props) {
    var getStore = useFluxible().getStore;
    var _a = __read(React.useState(''), 2), searchTerm = _a[0], setSearchTerm = _a[1];
    var QuickstartStorez = getStore(QuickstartStore);
    var quickstarts = QuickstartStorez.getQuickstarts();
    var divRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        var sectionId = props.currentRoute.params.quickstartId;
        var section = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("#".concat(sectionId));
        section === null || section === void 0 ? void 0 : section.scrollIntoView();
    }, [divRef, props.currentRoute.params.quickstartId]);
    var categories = {};
    // hide beta quickstarts
    each(quickstarts, function (category, name) {
        categories[name] = filter(category.platforms, function (p) { return p.beta !== true; }).sort(function (a, b) {
            return a.title.localeCompare(b.title);
        });
    });
    var results = doSearch(categories, searchTerm);
    // Mapping categories to dom refs
    var categoryRefs = {};
    CATEGORIES.forEach(function (cat) { return (categoryRefs[cat] = React.useRef(null)); });
    return (React.createElement(StickyContainer, null,
        React.createElement("div", { className: styles.quickstartsPage, ref: divRef },
            React.createElement(Container, { gutter: 'large', distribution: '1/4 3/4', gridGap: 8 },
                React.createElement(SidebarContainer, null,
                    React.createElement(Sidebar, { categoryRefs: categoryRefs })),
                React.createElement(MainContentContainer, null,
                    React.createElement(Hero, null),
                    React.createElement(SearchField, { value: searchTerm, performSearch: setSearchTerm }),
                    CATEGORIES.map(function (category) { return (React.createElement(Category, { key: category, name: category, quickstarts: results.quickstarts[category], ref: categoryRefs[category] })); }),
                    results.noResults && (React.createElement("div", { className: styles.noResults },
                        React.createElement("h2", null, "No Quickstarts matches your search term \"".concat(searchTerm, "\".")),
                        React.createElement("p", null, "There might be a spelling error in your search term, or we just don\u2019t support that language yet. Want to view a list of all Quickstarts again? Clear your search term above."))))))));
};
